import React, { Component } from 'react';
import moment from 'moment';
import { toast } from 'react-toastify';

import FormError from 'components/FormError';
import { DATE_TIME_FORMAT } from '../../../constants';
import { cancelSimoScheduledOperation } from 'api';
import { getGeneralModalError } from 'helpers/modals';
import Spinner from 'components/Spinner';

export class SimoScheduledActions extends Component {
  state = {
    loading: false,
  };

  handleDeleteAction = async (id) => {
    const { sub, findSub } = this.props;
    this.setState({ loading: true });
    try {
      await cancelSimoScheduledOperation(id);
      await findSub(sub.id);
      toast.success(`Scheduled operation deleted`);
    } catch (e) {
      const error = getGeneralModalError(
        e.response?.data ? e.response?.data : e,
      );
      toast.error(<FormError error={error} />);
    } finally {
      this.setState({ loading: false });
    }
  };

  render() {
    const { sub } = this.props;
    const { loading } = this.state;
    const scheduledOperations = sub?.scheduled_operations || [];
    return (
      <section className="mar-t" style={{ position: 'relative' }}>
        <h3>Scheduled Operations</h3>
        <table className="table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Name</th>
              <th>Status</th>
              <th>Execution Date</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {scheduledOperations.length > 0 &&
              scheduledOperations.map((operation) => (
                <tr key={operation.id}>
                  <td>{operation.id}</td>
                  <td>
                    {operation.name === 'immediate renewal'
                      ? 'renewal'
                      : operation.name}
                  </td>
                  <td>{operation.status}</td>
                  <td>
                    {operation.execution_dt &&
                      moment(operation.execution_dt).format(DATE_TIME_FORMAT)}
                  </td>
                  <td>
                    <button
                      type="button"
                      className="small-bs-btn btn btn-danger"
                      onClick={() => this.handleDeleteAction(operation.id)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            {scheduledOperations.length === 0 ? (
              <tr>
                <td colSpan="6">No scheduled operations yet</td>
              </tr>
            ) : null}
          </tbody>
        </table>
        <Spinner showLoader={loading} />
      </section>
    );
  }
}

export default SimoScheduledActions;
